
        var result = require("!!../../../node_modules/css-loader/index.js!./frontpage.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/frontpage/frontpage.component.css
// module id = 487
// module chunks = 2